import { render, staticRenderFns } from "./invreport_main.vue?vue&type=template&id=85255c82&scoped=true"
import script from "./invreport_main.vue?vue&type=script&lang=js"
export * from "./invreport_main.vue?vue&type=script&lang=js"
import style0 from "./invreport_main.vue?vue&type=style&index=0&id=85255c82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85255c82",
  null
  
)

export default component.exports